import api from './api';
import i18n from '@/plugins/i18n';

const state = {
	locale: null,
	showProductionBanner: false,
};

const mutations = {
	setLocale(state, locale) {
		locale.dateTimeFormat = locale.dateFormat + ' ' + locale.timeFormat;
		state.locale = locale;

		i18n.global.setLocaleMessage(locale.key, locale.messages);
		i18n.global.locale.value = locale.key;
		localStorage.setItem('locale', locale.key);
	},

	setShowProductionBanner(state, value) {
		state.showProductionBanner = value;
	},
};

const getters = {
	showProductionBanner: (state) => state.showProductionBanner,
};

const actions = {
	async load({ commit, dispatch, rootState, state }, { browserLocale, tenant }) {
		if (tenant !== null && rootState.auth.token) {
			const decodedToken = JSON.parse(atob(rootState.auth.token.split('.')[1]));
			if (decodedToken && decodedToken.tenant && decodedToken.tenant !== window.localStorage.getItem('tenant')) {
				window.localStorage.setItem('tenant', decodedToken.tenant);
				window.location.reload();
				return;
			}
		}
		let localeKey;

		//Try to recover locale from user
		if (rootState.auth.token) {
			const response = await api.getUserLocale(localeKey);
			const userLocaleKey = response.data.locale;
			if (userLocaleKey) {
				localeKey = userLocaleKey;
				console.log('Selected user locale: ' + localeKey);
			}
		}

		//Try to recover locale from session
		let storedKey = localStorage.getItem('locale');
		if (!localeKey && storedKey) {
			localeKey = storedKey;
			console.log('Selected stored locale: ' + localeKey);
		}

		//Try to use browser language
		if (!localeKey && browserLocale) {
			localeKey = browserLocale;
			console.log('Selected browser locale: ' + localeKey);
		}

		//Alternatively, select default locale from locale list
		if (!localeKey && rootState.locals.default) {
			localeKey = rootState.locals.default;
			console.log('Selected default locale: ' + localeKey);
		}

		//As a last option, select English
		if (!localeKey) {
			localeKey = 'en-US';
			console.log('No locale found, revert to ' + localeKey);
		}

		//Get locale from key and set it to current
		await dispatch('setLocale', localeKey);
	},

	async setLocale({ commit, state, dispatch }, localeKey) {
		try {
			const locale = await dispatch('locales/getLocale', localeKey, { root: true });

			commit('setLocale', locale);
		} catch (err) {
			console.log('Could not load locale from API!', err);
		}

		//Only show an error to the user if there are no locale keys in the storage
		if (!state.locale) {
			dispatch('lifecycle/fatal', { message: 'Could not load language! Please make sure you are online' }, { root: true });
		}
	},

	async changeLocale({ dispatch }, localeKey) {
		//Save locale to my user
		api.saveLocale(localeKey)
			.then(async (response) => {
				console.log('Successfully changed locale on my user');

				//Set new locale
				dispatch('setLocale', localeKey);

				const registration = await navigator.serviceWorker.ready;

				if (registration.active) {
					registration.active.postMessage({
						type: 'CHANGE_LOCALE',
						locale: localeKey,
					});
				}
			})
			.catch((err) => {
				console.log("Can't save new locale to my user", err);
			});
	},

	async changeProductionBanner({ commit }, enabled) {
		try {
			await api.saveProductionBanner(enabled);
			commit('setShowProductionBanner', enabled);
		} catch (err) {
			console.error("Can't save production banner for user", err);
		}
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
